var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("h3", { staticStyle: { margin: "1rem", "font-size": "1.4rem" } }, [
        _vm._v("平台优惠价差报表")
      ]),
      _c(
        "div",
        { staticClass: "block" },
        [
          _c("span", { staticClass: "demonstration" }, [_vm._v("选择日期")]),
          _c("el-date-picker", {
            staticStyle: { width: "20rem !important" },
            attrs: {
              editable: false,
              size: "small",
              type: "daterange",
              "range-separator": "~",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "value-format": "timestamp",
              "picker-options": _vm.pickerOptionsLimit
            },
            model: {
              value: _vm.datePickerValue,
              callback: function($$v) {
                _vm.datePickerValue = $$v
              },
              expression: "datePickerValue"
            }
          }),
          _c(
            "el-select",
            {
              attrs: {
                "value-key": "statTag",
                size: "small",
                placeholder: "请选择站点"
              },
              model: {
                value: _vm.selectedStation,
                callback: function($$v) {
                  _vm.selectedStation = $$v
                },
                expression: "selectedStation"
              }
            },
            [
              _c("el-option", {
                attrs: { label: "请选择站点", value: 0, disabled: "" }
              }),
              _vm._l(_vm.asyncStations, function(item) {
                return _c("el-option", {
                  key: item.ID,
                  attrs: { label: item.statTag, value: item }
                })
              })
            ],
            2
          ),
          _c(
            "el-button",
            {
              attrs: {
                loading: _vm.downloadLoading,
                size: "small",
                type: "primary"
              },
              on: { click: _vm.loadData }
            },
            [_vm._v("查询")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                loading: _vm.downloadLoading,
                size: "small",
                type: "warning",
                icon: "el-icon-document"
              },
              on: {
                click: function($event) {
                  return _vm.exportExcel(_vm.excelSheets, "平台优惠价差报表")
                }
              }
            },
            [_vm._v(" 下载报表 ")]
          )
        ],
        1
      ),
      _c("br"),
      _c(
        "el-table",
        {
          ref: "stationDailyPlatformDiscountData",
          attrs: {
            id: "stationDailyPlatformDiscountData",
            data: _vm.stationDailyPlatformDiscountData,
            "highlight-current-row": "",
            height: "600",
            "summary-method": _vm.getSummaries,
            "show-summary": "",
            "cell-style": _vm.cellStyle,
            "header-cell-style": { "text-align": "center" },
            border: ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "平台", prop: "platName" }
          }),
          _c(
            "el-table-column",
            { attrs: { align: "center", label: "0#柴油" } },
            [
              _c("el-table-column", {
                attrs: { align: "center", prop: "monthNums0", label: "总升数" }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthAmount0",
                  label: "总实收"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthDiscount0",
                  label: "总优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthDiffPrice0",
                  label: "优惠均价"
                }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            { attrs: { align: "center", label: "92#汽油" } },
            [
              _c("el-table-column", {
                attrs: { align: "center", prop: "monthNums92", label: "总升数" }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthAmount92",
                  label: "总实收"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthDiscount92",
                  label: "总优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthDiffPrice92",
                  label: "优惠均价"
                }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            { attrs: { align: "center", label: "95#汽油" } },
            [
              _c("el-table-column", {
                attrs: { align: "center", prop: "monthNums95", label: "总升数" }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthAmount95",
                  label: "总实收"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthDiscount95",
                  label: "总优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthDiffPrice95",
                  label: "优惠均价"
                }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            { attrs: { align: "center", label: "汇总" } },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthCountStations",
                  label: "油站数"
                }
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "monthNums", label: "总升数" }
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "monthAmount", label: "总实收" }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthDiscount",
                  label: "总优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthDiffPrice",
                  label: "总均价"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }